__turbopack_context__.v({
  "className": "geologica_a5840ea8-module__o3H0Oq__className",
  "variable": "geologica_a5840ea8-module__o3H0Oq__variable",
});
